import { apiRequest } from '../client'
import type {
  CompanyProfile,
  Restaurant,
  RestaurantEdgeSettings,
  RestaurantEdgeSettingsPatch,
  RestaurantScheduling,
  RestaurantVisibility,
  SchedulingPreviewResponse,
} from '../types'

export const restaurantsApi = {
  list: () =>
    apiRequest<{ items: Array<Restaurant> }>('/api/v0/admin/restaurants'),
  get: (id: number) =>
    apiRequest<Restaurant>(`/api/v0/admin/restaurants/${id}`),
  create: (body: {
    name: string
    code: string
    timezone?: string
    onlineOrderingEnabled?: boolean
    defaultSafetyBufferQty?: number
    inventoryTrackingEnabled?: boolean
    inventoryCountShowExpected?: boolean
    companyProfile?: CompanyProfile
    visibility?: RestaurantVisibility
    enrollmentCode?: string
    /** webbill pseudo-GLN a delivery note is addressed to; blank clears it. */
    webbillReceiverRef?: string
  }) =>
    apiRequest<Restaurant>(`/api/v0/admin/restaurants`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  update: (
    id: number,
    body: Partial<{
      name: string
      timezone: string
      onlineOrderingEnabled: boolean
      defaultSafetyBufferQty: number
      inventoryTrackingEnabled: boolean
      inventoryCountShowExpected: boolean
      companyProfile: CompanyProfile
      visibility: RestaurantVisibility
      enrollmentCode: string
      /** webbill pseudo-GLN a delivery note is addressed to; a provided blank clears it. */
      webbillReceiverRef: string
    }>,
  ) =>
    apiRequest<Restaurant>(`/api/v0/admin/restaurants/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  getScheduling: (id: number) =>
    apiRequest<RestaurantScheduling>(
      `/api/v0/admin/restaurants/${id}/scheduling`,
    ),
  putScheduling: (id: number, body: RestaurantScheduling) =>
    apiRequest<RestaurantScheduling>(
      `/api/v0/admin/restaurants/${id}/scheduling`,
      {
        method: 'PUT',
        body: JSON.stringify(body),
      },
    ),
  previewScheduling: (
    id: number,
    body: { scheduling: RestaurantScheduling; date: string; nowLocal: string },
  ) =>
    apiRequest<SchedulingPreviewResponse>(
      `/api/v0/admin/restaurants/${id}/scheduling/preview`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
    ),
  getEdgeSettings: (id: number) =>
    apiRequest<RestaurantEdgeSettings>(
      `/api/v0/admin/restaurants/${id}/edge-settings`,
    ),
  putEdgeSettings: (id: number, body: RestaurantEdgeSettingsPatch) =>
    apiRequest<{ ok: boolean; bundleId: number; version: number }>(
      `/api/v0/admin/restaurants/${id}/edge-settings`,
      {
        method: 'PUT',
        body: JSON.stringify(body),
      },
    ),
}
